import { render, staticRenderFns } from "./InterestFollowUpChangeActivationType.vue?vue&type=template&id=6a054a6c&"
import script from "./InterestFollowUpChangeActivationType.vue?vue&type=script&lang=js&"
export * from "./InterestFollowUpChangeActivationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports